var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 177,
    viewBox: "0 0 178 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89 168.519C133.193 168.519 169.019 132.693 169.019 88.5C169.019 44.3067 133.193 8.48096 89 8.48096C44.8067 8.48096 8.98096 44.3067 8.98096 88.5C8.98096 132.693 44.8067 168.519 89 168.519ZM89.0171 156.591C126.615 156.591 157.094 126.112 157.094 88.5145C157.094 50.9167 126.615 20.4376 89.0171 20.4376C51.4192 20.4376 20.9401 50.9167 20.9401 88.5145C20.9401 126.112 51.4192 156.591 89.0171 156.591Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2861 168.519C134.836 168.511 169.327 132.688 169.327 88.5C169.327 44.3116 134.836 8.48884 92.2861 8.48096V20.4376C128.483 20.448 157.823 50.9231 157.823 88.5145C157.823 126.106 128.483 156.581 92.2861 156.591V168.519Z",
    fill: "#0F253B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 88.5,
    r: 72.7857,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.7db6f8f3fa029d24f6bbe8cd38df05cc.svg";
export { ForwardRef as ReactComponent };